module.exports = {"620621100":"三雷镇","620621101":"东坝镇","620621102":"泉山镇","620621103":"西渠镇","620621104":"东湖镇","620621105":"红沙岗镇","620621106":"昌宁镇","620621107":"重兴镇","620621108":"薛百镇","620621109":"大坝镇","620621110":"苏武镇","620621111":"大滩镇","620621112":"双茨科镇","620621113":"红沙梁镇","620621201":"蔡旗乡","620621206":"夹河乡","620621210":"收成乡","620621211":"南湖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620621.json
// module id = 2703
// module chunks = 0